import { gsap, SplitText, CustomEase } from '../global/gsap';

const initTitleReveals = (els) => {
    const customEase = 'M0,0 C0.668,0 0.132,1 1,1';

    els.forEach((el) => {
        const section = el.closest('.js-section');
        let otherEls = false;
        if (section) {
            otherEls = section.querySelectorAll('.js-title-reveal-extra');
        }
        const splitEl = new SplitText(el, { type: 'lines, words', linesClass: 'line' });

        gsap.set(otherEls, {
            autoAlpha: 0
        });

        gsap.set(splitEl.words, {
            autoAlpha: 0,
            yPercent: 100
        });

        const splitTl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
            }
        });

        splitTl.to(splitEl.words, {
            yPercent: 0,
            autoAlpha: 1,
            stagger: 0.035,
            ease: CustomEase.create('custom', customEase),
            duration: 1.1,
            onStart: () => {
                gsap.set(el, {
                    opacity: 1
                });
            }
        });

        if (section && otherEls) {
            splitTl.to(otherEls, {
                autoAlpha: 1,
                stagger: 0.15,
                duration: 0.75
            }, '-=.5');
        }
    });
};

export default initTitleReveals;
